function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 326"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon metro-warning",
    d: "m14.571 4.1 10.057 20.047H4.514L14.571 4.1zm0-2.174a1.735 1.735 0 0 0-1.427 1.046L2.9 23.391c-.785 1.4-.117 2.537 1.484 2.537h20.374c1.6 0 2.269-1.142 1.484-2.537L16 2.974a1.735 1.735 0 0 0-1.427-1.046zm1.5 19.5a1.5 1.5 0 1 1-1.5-1.5 1.5 1.5 0 0 1 1.5 1.502zm-1.5-3a1.5 1.5 0 0 1-1.5-1.5v-4.5a1.5 1.5 0 0 1 3 0v4.5a1.5 1.5 0 0 1-1.5 1.502z",
    transform: "translate(-2.57 -1.928)",
    style: {
      fill: "#DB162F"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.76cf44b82c5ebbc966d18c31a1560123.svg";
export { ForwardRef as ReactComponent };